import * as React from "react"

function SvgComponent(props) {
  return (
    <svg viewBox="0 0 15 15" {...props}>
      <title>{"Artboard"}</title>
      <path
        d="M7.5 0C3.36 0 0 3.36 0 7.5 0 11.64 3.36 15 7.5 15c4.14 0 7.5-3.36 7.5-7.5C15 3.36 11.64 0 7.5 0zM7 3.5c0-.28.22-.5.5-.5s.5.22.5.5V8c0 .28-.22.5-.5.5S7 8.28 7 8V3.5zm.5 8.5c-.55 0-1-.45-1-1s.45-1 1-1 1 .45 1 1-.45 1-1 1z"
        fill="#F15461"
        fillRule="nonzero"
      />
    </svg>
  )
}

export default SvgComponent
